import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Check } from "lucide-react";

export default function ProgramPage() {
  const [days, setDays] = useState([]);
  const [progress, setProgress] = useState({});
  const [currentDay, setCurrentDay] = useState(1);

  useEffect(() => {
    (async () => {
      const [d, ov] = await Promise.all([
        api.get("/program/days"),
        api.get("/program/overview"),
      ]);
      setDays(d.data.days);
      setCurrentDay(ov.data.current_day);
      const map = {};
      for (const p of ov.data.progress) map[p.day] = p;
      setProgress(map);
    })();
  }, []);

  const isComplete = (day) => {
    const p = progress[day] || {};
    return p.move_done && p.goal_done && p.fuel_done && p.proof_done;
  };

  return (
    <div className="fade-up">
      <p className="eyebrow">The 30-day rebuild</p>
      <h1 className="font-display font-black text-3xl md:text-5xl mt-2 brand-underline">
        CINDR // REBUILD 30
      </h1>
      <p className="text-zinc-400 mt-6 max-w-2xl">
        Thirty days of intentional MOVE, FUEL, MIND and RECOVER. Every day is proof you can trust yourself.
      </p>

      <div className="grid grid-cols-5 md:grid-cols-6 lg:grid-cols-10 gap-2 md:gap-3 mt-10" data-testid="program-grid">
        {days.map((d) => {
          const done = isComplete(d.day);
          const isToday = d.day === currentDay;
          return (
            <Link
              key={d.day}
              to={`/program/${d.day}`}
              data-testid={`program-day-${d.day}`}
              className="aspect-square flex flex-col items-center justify-center relative transition-all"
              style={{
                background: done ? "#FF0055" : isToday ? "#1E1E1E" : "#121212",
                border: `1px solid ${isToday ? "#FF0055" : done ? "#FF0055" : "#27272A"}`,
                color: done ? "white" : isToday ? "white" : "#A1A1AA",
              }}
            >
              <span className="eyebrow text-[9px]" style={{ color: done ? "rgba(255,255,255,0.75)" : undefined }}>
                Day
              </span>
              <span className="font-display font-black text-xl md:text-2xl">{d.day}</span>
              {done && <Check size={14} strokeWidth={3} className="absolute top-1 right-1" />}
            </Link>
          );
        })}
      </div>

      <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3">
        {["MOVE", "FUEL", "MIND", "RECOVER"].map((pillar) => (
          <div className="card" key={pillar}>
            <p className="eyebrow" style={{ color: "#FF0055" }}>{pillar}</p>
            <p className="text-xs text-zinc-400 mt-3">
              {pillar === "MOVE" && "Strength, cardio & daily movement."}
              {pillar === "FUEL" && "Protein, real food, no bans."}
              {pillar === "MIND" && "Confidence & self-trust."}
              {pillar === "RECOVER" && "Mobility, sleep & rest."}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
